export const INITIAL_EDITOR_JS_DATA = {
    time: new Date().getTime(),
    blocks: [],
};